module.exports = __webpack_public_path__ + "static/media/rm_06-33.f17a043c.png";